import { ProspectFormComponent } from '@zayan-erp/sales';
import { AfterViewInit, Component, DestroyRef, inject } from '@angular/core';
import { Subject, map } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { PublicLogSource, PublicLogsService } from '@zayan-erp/shared';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';

@Component({
  imports: [ProspectFormComponent, RouterLink],
  templateUrl: './public-prospect.component.html'
})
export class PublicProspectComponent implements AfterViewInit {
  #publicLogsService = inject(PublicLogsService);
  #destroyRef = inject(DestroyRef);
  private onSubmitButtonClickSubject = new Subject<void>();
  onSubmitButtonClickObservable = this.onSubmitButtonClickSubject.asObservable();

  ngAfterViewInit() {
    this.#publicLogsService
      .postPublicLog(PublicLogSource.ProspectPage, `salesOfficeID=${this.salesOfficeId()}`)
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe();
  }

  #route = inject(ActivatedRoute);
  salesOfficeId = toSignal(this.#route.paramMap.pipe(map(params => params.get('salesOfficeId'))), {
    initialValue: null
  });

  onSaveButtonClick() {
    this.onSubmitButtonClickSubject.next();
  }
}
